import * as React from 'react';

// @ts-expect-error
import capitalize from 'underscore.string/capitalize';

import type {IntakeFormSettings} from '../../../../../ui/inbox/chat/settings/actions-options/consts';

import {Stack} from '../layout/stack/stack';
import {Body} from '../typography/body';

import {getFormFieldLabel} from './helpers';

import styles from './chat-preview.module.css';

type Props = {
    conversationStarter: string;
    intakeFormSettings: IntakeFormSettings;
};

const EXPECTED_FIELD_ORDER = ['name', 'email', 'phone', 'companyName'];

export function OnlineContent(props: Props) {
    const orderedSelectedFields = EXPECTED_FIELD_ORDER.filter(
        // @ts-expect-error
        (field) => field === 'name' || props.intakeFormSettings.fields.includes(field)
    );

    return (
        <Stack spacing={8}>
            <Stack isHorizontal={true} spacing={8}>
                <Body size='mini' isItalic={true}>
                    Opening message
                </Body>
            </Stack>
            <div className={styles['chat-bubble--outgoing']}>{props.conversationStarter}</div>
            {props.intakeFormSettings.type === 'CONVERSATIONAL' ? (
                <div className={styles['chat-bubble--outgoing']}>What’s your name?</div>
            ) : (
                <Stack spacing={8}>
                    <div className={styles['chat-bubble--outgoing']}>
                        Can you tell me a bit about yourself first?
                    </div>
                    <div className={styles['online-form-container']}>
                        {orderedSelectedFields.map((field) => (
                            <Stack key={field} spacing={8}>
                                <Body size='small'>
                                    {capitalize(field === 'companyName' ? 'company name' : field)}
                                </Body>
                                <div className={styles['form-field']}>
                                    {getFormFieldLabel(field)}
                                </div>
                            </Stack>
                        ))}
                    </div>
                </Stack>
            )}
        </Stack>
    );
}
